<template>
    <div class="vue-active-garage-block" v-click-outside="() => { this.open = false }" :class="{'no-garage': hasActiveGarage === false}">
        <template v-if="hasActiveGarage === true">
            <div class="dropdown show">
                <a class="dropdown-toggle" href="#" role="button" id="dropdown-garage" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="open" @click.prevent="handleClick" :class="{'is-active': open === true}">
                  <span class="color-white d-block">Uw CarProf</span>
                    {{ activeGarage.title }}
                </a>

                <div class="dropdown-menu" aria-labelledby="dropdown-garage" :class="{ 'show': open === true }">
                    <div class="inner">
                        <h2 class="virtual-h4"><a :href="activeGarage.url">{{ activeGarage.title }}</a></h2>

                        <div class="info d-flex justify-content-between align-content-center">
                            <div class="contact">
                                <address>
                                    <p>
                                        {{ activeGarage.streetNumber }}<br>
                                        {{ activeGarage.postalCodePlace }}<br>
                                    </p>

                                    <p>
                                        <template v-if="this.parsedPhonenumber">
                                            <a :href="`tel:${ parsedPhonenumber }`">{{ activeGarage.tel }}</a><br>
                                        </template>

                                        <a :href="'mailto:'+activeGarage.email">Stuur een mail</a>
                                    </p>
                                </address>
                            </div>

                            <div class="klantenvertellen" v-if="hasKlantenvertellen">
                                {{ activeGarage.klantenvertellen.averageScore }}
                            </div>
                        </div>

                        <a :href="`${activeGarage.url}/afspraak-maken`" class="btn-arrow ml-0 mr-0">Afspraak maken</a>

                        <a :href="`${activeGarage.url}/offerte-aanvragen`" class="btn-arrow-inverse mt-3">Offerte aanvragen</a>

                        <hr class="divider">

                        <a href="/vestigingen" class="cta-link">Andere vestiging selecteren</a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ActiveGarageMixin from "../mixins/ActiveGarageMixin";

export default {
    name: "ActiveGarageBlock",

    mixins: [ActiveGarageMixin],

    props: ['modalBus'],

    data() {
        return {
            open: false,
        }
    },

    methods: {
        handleClick() {
            this.open = ! this.open;
        }
    }
}
</script>